var _circle, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCircleHeart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 25,
    r: 24.5,
    fill: "white",
    stroke: "black"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_410_11419)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.5 15.917C29.3739 15.9345 28.2724 16.2488 27.3067 16.8283C26.341 17.4077 25.5453 18.2317 25 19.217C24.4546 18.2317 23.6589 17.4077 22.6932 16.8283C21.7275 16.2488 20.626 15.9345 19.5 15.917C17.7049 15.995 16.0137 16.7802 14.7957 18.1012C13.5778 19.4222 12.9322 21.1715 13 22.967C13 29.742 23.956 37.567 24.422 37.899L25 38.308L25.578 37.899C26.044 37.569 37 29.742 37 22.967C37.0677 21.1715 36.4221 19.4222 35.2042 18.1012C33.9863 16.7802 32.295 15.995 30.5 15.917ZM25 35.846C21.747 33.416 15 27.446 15 22.967C14.9316 21.7017 15.3663 20.4607 16.2093 19.5147C17.0523 18.5687 18.2352 17.9943 19.5 17.917C20.7647 17.9943 21.9476 18.5687 22.7906 19.5147C23.6336 20.4607 24.0683 21.7017 24 22.967H26C25.9316 21.7017 26.3663 20.4607 27.2093 19.5147C28.0523 18.5687 29.2352 17.9943 30.5 17.917C31.7647 17.9943 32.9476 18.5687 33.7906 19.5147C34.6336 20.4607 35.0683 21.7017 35 22.967C35 27.448 28.253 33.416 25 35.846Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_410_11419"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(13 15)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleHeart);
export default __webpack_public_path__ + "static/media/circle-heart.544ceaa92fdc08f9a82e0a5b5e9c161b.svg";
export { ForwardRef as ReactComponent };